<template lang="pug">
b-modal#addTurnoverTier(
  ref="addTurnoverTier"
  :title="$t('ui.combine.add_turnover_tier')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group.mb-0
      label {{ $t('ui.turnover') }}
      i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_turnover')")
      DebounceInput(
        ref="turnover"
        size="sm"
        required
        type="text"
        :dirty="$v.turnover.$dirty"
        :error="$v.turnover.$error"
        v-model.trim.lazy="$v.turnover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.turnover" :name="$t('ui.turnover')")
    b-form-group.mb-0
      label {{ $t('ui.rebate_rate') }}
      i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_rebate_rate')")
      DebounceInput(
        ref="rebate_rate"
        size="sm"
        required
        type="text"
        :dirty="$v.rebate_rate.$dirty"
        :error="$v.rebate_rate.$error"
        v-model.trim.lazy="$v.rebate_rate.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.rebate_rate" :name="$t('ui.rebate_rate')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      turnover: 0,
      rebate_rate: 0,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
  },
  validations: {
    turnover: {
      decimal,
      required,
      minValue: minValue(1)
    },
    rebate_rate: {
      decimal,
      required,
      minValue: minValue(0.01)
    }
  },
  watch : {
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.turnoverTierAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          turnover: this.turnover,
          rebate_rate: this.rebate_rate,
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.addTurnoverTier.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_turnover_tier", this.feedback.status);
                  this.$refs.addTurnoverTier.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.turnover = 0;
      this.rebate_rate = 0;
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.turnover.$el.focus();
    }
  }
};
</script>
